import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import { useGetCertOrdersQuery } from "../../../features/CallApi";
import LoadScreen from "../../UI/LoadScreen";
import { CerteficateList } from "./CerteficateList";


export const CerteficateAdmin = () => {

    const navigate = useNavigate();
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [stringFilter, setStringFilter] = useState("");
    const { isLoading, data: orders, refetch, error, isFetching } = useGetCertOrdersQuery({ pageIndex, pageSize, stringFilter });

    return (
        <Container fluid>
            <h3>Заказы сертификатов ЛЦ</h3>
            {error ?
                <div>
                    {error && <div>
                        <h1>Error code: {error.status}</h1>
                        <p>{error.data}</p>
                    </div>
                    }
                </div> :
                <div>
                    <div className="d-flex">
                        <input type={`text`} id="stringFilter" onChange={
                            (e) => setTimeout(() => { setStringFilter(e.target.value) }, 2000)}
                            placeholder="Поиск.." name="stringFilter" className="form-control" />
                    </div>
                    <div>
                        {isLoading ?
                            <LoadScreen></LoadScreen> :
                            <CerteficateList pageIndex={pageIndex} setPageIndex={setPageIndex} navigate={navigate} orders={orders.getOrder} totalPages={orders.totalPages} />
                        }
                    </div>
                </div>
            }

        </Container>
    )
}